import { isNil } from 'lodash-es';

export const getForecastLabel = ({
  forecast_index,
  final_forecast,
}) => {
  if (isNil(forecast_index)) return '';

  if (final_forecast) return 'Final Forecast';
  return forecast_index === 0 ? 'Early Look' : `Forecast ${forecast_index}`;
};

export const decorateTooltipForecastLabel = (label) => {
  const shortForecastPattern = /^F\d+$/;

  if (shortForecastPattern.test(label)) return label.replace('F', 'Forecast ');
  return label;
};
